import { createSelector } from 'reselect';
import { GDPR_PREFERENCES_COOKIE } from '@wkda/gdprlib';
import { get, getOr } from 'lodash/fp';
import { STORE_KEY } from '../duck';

const getGdprCookieBanner = get([STORE_KEY, 'gdprCookieBanner']);

export const isGdprBannerLoaded = createSelector(
  getGdprCookieBanner,
  getOr(false, 'isLoaded'),
);

export const getGdprBannerContent = createSelector(
  getGdprCookieBanner,
  getOr(null, ['result', 'content']),
  (res) => {
    try {
      return JSON.parse(res.result.content);
    } catch (error) {
      return null;
    }
  },
);

export const getGdprPreferencesCookie = createSelector(
  getGdprCookieBanner,
  get([GDPR_PREFERENCES_COOKIE]),
);
